/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Product methods
 * -----------------------------------------------------------------------------
 *
 * @namespace product
 */

import axios from 'axios';
import Flickity from 'flickity';
import 'flickity-as-nav-for';
import 'flickity-fullscreen';
import zoomio from 'zoomio';
import enquire from 'enquire.js';
// import detectIt from 'detect-it';
import scrollMonitor from 'scrollmonitor';

var productMethods = {
	data: function data() {
		return {
			enableHistoryState: false,
			isProductToolbarMobileOpen: false,
			product: {},
			currentVariant: {}
		};
	},


	methods: {

		/**
		 * Product Single
		 */
		_initProduct: function _initProduct() {
			var $container = $('[data-template="product"]');
			var $productTabs = $(app.selectors.productTabs);
			var $productToolbarMobile = $(app.selectors.productToolbarMobile);
			var $imageZoom = $(app.selectors.imageZoom);
			var productObj = app.selectors.productObj;

			// product tabs add active class to 1st child
			$productTabs.find('.nav-item').first().find('a').addClass('active');
			$productTabs.find('.tab-content .tab-pane').first().addClass('active');

			// stop parsing if we are not in the product template
			if (app.currentTemplate !== 'product') {
				return;
			}

			// set data
			app.product = JSON.parse($(productObj).html());
			var productData = JSON.parse($(productObj).html());
			app.product = productData.product;
			app.product.options_with_values = productData.options_with_values;

			// assign the product cart limit
			app.product.tags.forEach(function (tag) {
				if (tag.match('cart-limit')) {
					var cartLimit = tag.replace('cart-limit-', '');
					app.product.cart_limit = parseFloat(cartLimit);
					// console.log(app.product);
				}
			});

			// app.enableHistoryState = $container.data('enable-history-state');
			app.enableHistoryState = false;
			app._getVariant();


			function registerMobileToolbar() {
				var productFormPosition = $(app.selectors.productForm).position();
				var formWatcher = scrollMonitor.create($(app.selectors.productForm));
				var footerWatcher = scrollMonitor.create($('[data-footer-bottom]'));
				$productToolbarMobile.show();

				window.addEventListener('scroll', function () {
					var windowScrollY = window.scrollY;

					if (windowScrollY > productFormPosition.top) {
						formWatcher.exitViewport(function () {
							// console.log( 'I have left the viewport' )
							$productToolbarMobile.addClass('semi-opened');
						});

						formWatcher.enterViewport(function () {
							// console.log( 'I have entered the viewport' )
							$productToolbarMobile.removeClass('semi-opened fully-opened');
							if (app.isProductToolbarMobileOpen) {
								app.isProductToolbarMobileOpen = false;
							}
						});

						footerWatcher.exitViewport(function () {
							$productToolbarMobile.addClass('semi-opened');
						});

						footerWatcher.enterViewport(function () {
							$productToolbarMobile.removeClass('semi-opened fully-opened');
							if (app.isProductToolbarMobileOpen) {
								app.isProductToolbarMobileOpen = false;
							}
						});
					} else {
						$productToolbarMobile.removeClass('semi-opened fully-opened');
						if (app.isProductToolbarMobileOpen) {
							app.isProductToolbarMobileOpen = false;
						}
					}
				}); // add scroll event listener
			}

			// mobile product form - sticky toolbar
			enquire.register('screen and (min-width: 720px)', {
				setup: function setup() {
					registerMobileToolbar();
				},
				match: function match() {
					$productToolbarMobile.hide();

					$imageZoom.zoomio({
						fadeduration: 200
					});
				},
				unmatch: function unmatch() {
					registerMobileToolbar();
				}
			});
		},


		/**
		 * Event when product option select or input changes
		 *
		 */
		_getVariant: function _getVariant(event) {
			var variant = app._getVariantFromOptions(event);
			// console.log(variant);

			// stop parsing if there is no variant info
			if (!variant) {
				app.currentVariant = {};
				return;
			}

			app._updateImages(variant, event);
			app._checkWishlist(variant);

			if (app.currentTemplate === 'collection') {
				// collection
				var productId = $(event.currentTarget).closest(app.selectors.productForm).data('product-id');
				var product = app.collection.products.find(function (x) {
					return x.id === productId;
				});
				product.current_variant = variant;
			} else if (app.currentTemplate === 'product') {
				app.currentVariant = variant;
				if (app.enableHistoryState) {
					app._updateHistoryState(variant);
				}
			}
		},


		/**
		 * Get the currently selected options from add-to-cart form.
		 *
		 * @return {array} options - Values of currently selected variants
		 */
		_getCurrentOptions: function _getCurrentOptions(event) {
			var singleOptionSelector = app.selectors.singleOptionSelector;
			var currentOptions = [];
			var $container = void 0;

			// eslint-disable-next-line prefer-const
			$container = event ? $(event.currentTarget).closest(app.selectors.productForm) : $(app.selectors.productForm);

			$.map($(singleOptionSelector, $container), function (element) {
				var $element = $(element);
				var type = $element.attr('type');
				var currentOption = {};

				if (type === 'radio' || type === 'checkbox') {
					if ($element[0].checked) {
						currentOption.value = $element.val();
						currentOption.index = $element.data('index');
						currentOptions.push(currentOption);
					}
				} else {
					currentOption.value = $element.val();
					currentOption.index = $element.data('index');
					currentOptions.push(currentOption);
				}
			});

			return currentOptions;
		},


		/**
		 * Find variant based on selected values.
		 *
		 * @param  {array} selectedValues - Values of variant inputs
		 * @return {object || undefined} found - Variant object from product.variants
		 */
		_getVariantFromOptions: function _getVariantFromOptions(event) {
			var selectedValues = app._getCurrentOptions(event);
			var variants = void 0;
			var found = false;

			if (app.currentTemplate === 'collection') {
				// collection
				var productId = $(event.currentTarget).closest(app.selectors.productForm).data('product-id');
				var product = app.collection.products.find(function (x) {
					return x.id === productId;
				});
				variants = product.variants;
			} else if (app.currentTemplate === 'product') {
				// product
				variants = app.product.variants;
			}

			variants.forEach(function (variant) {
				var satisfied = true;

				selectedValues.forEach(function (option) {
					if (satisfied) {
						satisfied = option.value === variant[option.index];
					}
				});

				if (satisfied) {
					found = variant;
				}
			});

			return found || null;
		},


		/**
		 * Update history state for product deeplinking
		 *
		 * @param  {variant} variant - Currently selected variant
		 * @return {k}         [description]
		 */
		_updateHistoryState: function _updateHistoryState(variant) {
			if (!history.replaceState || !variant) {
				return;
			}

			var newUrl = void 0;

			var showReviewForm = app._getUrlParameter('showReviewForm');

			if (showReviewForm === '') {
				newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
			} else {
				newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id + "&showReviewForm=" + showReviewForm;
			}

			window.history.replaceState({
				path: newUrl
			}, '', newUrl);
		},


		/**
		 * Find variant image and scroll to this image
		 * works for all product page templates
		 * can be extended to update all images upon variant selection
		 *
		 * @param  {variant} variant - Currently selected variant
		 */
		_updateImages: function _updateImages(variant, event) {
			var variantImage = variant.featured_image || {};
			var variantTitle = variant.title;
			var templateType = $('[data-product-template]').data('product-template');
			var $scrollTarget = $("[data-variant-title=\"" + variantTitle + "\"]");
			var $container = void 0;
			var currentVariantImage = void 0;

			if (app.currentTemplate === 'collection') {
				$container = $(event.currentTarget).closest(app.selectors.productForm);
				var productId = $container.data('product-id');
				var product = app.collection.products.find(function (x) {
					return x.id === productId;
				});
				if (product.current_variant.featured_image) {
					currentVariantImage = product.current_variant.featured_image.src || {};
				} else {
					currentVariantImage = product.featured_image || {};
				}
			} else if (app.currentTemplate === 'product') {
				$container = $('[data-template="product"]');
				currentVariantImage = app.currentVariant.featured_image || {};
			}

			var $carousel = $container.find('[data-carousel-main]');

			if (variantImage.src === currentVariantImage.src) {
				return;
			}

			enquire.register('screen and (min-width: 720px)', {
				match: function match() {
					// For the 'minimal' product template
					// Scroll to variant image unless it's the first photo on load
					if (templateType === 'minimal' && $scrollTarget[0]) {
						$('html, body').animate({
							scrollTop: $scrollTarget.offset().top
						}, 350);
					}
				}
			});

			if ($carousel.length > 0) {
				var flkty = Flickity.data($carousel[0]);

				if (flkty === 'undefined' || typeof flkty === 'undefined') {
					return;
				}

				var cellElements = flkty.getCellElements();
				cellElements.forEach(function (element, index) {
					var imgAlt = $(element).data('variant-title');
					if (variantTitle.indexOf(imgAlt) !== -1) {
						flkty.selectCell(index, true, false); // value, isWrapped, isInstant
					}
				});
			}
		},


		/**
		 * Mobile toolbar - product form - options
		 */
		_toggleProductToolbarMobile: function _toggleProductToolbarMobile() {
			var $productToolbarMobile = $(app.selectors.productToolbarMobile);
			app.isProductToolbarMobileOpen = !app.isProductToolbarMobileOpen;
			$productToolbarMobile.toggleClass('fully-opened');
		}
	}
};

export default productMethods;